import React, {Component, Fragment, useEffect, useState} from 'react'
import Counter from "../../../components/counter";
import ProgressBar from "@ramonak/react-progress-bar";
import {getDeviseSymbol} from "../../../../../i18n";

export default function ScreenBarPartner({context,campagneData,mini}){

    const partnerMontant=campagneData?.partnerMontant || 1

    const total=campagneData.stats.total.sum.total/partnerMontant


    let bonus=null
    let _objectif=campagneData.objectif
    if(_objectif<total && Array.isArray(campagneData?.bonus) && campagneData?.bonus.length>0){
        bonus=campagneData.bonus.find(b=>b>total)
        if(!bonus){
            bonus=campagneData.bonus.at(-1)
        }
    }
    if(bonus){
        _objectif=bonus
    }

    const percent=(_objectif>0 ? (total/_objectif)*100 : 0)
    let displayPercent=(Number(campagneData.objectif)>0 ? (total/campagneData.objectif)*100 : 0)
    let progressColor=campagneData.config?.primaryColor || "#13A0BB"
    let progressLabelColor="#000"

    let donorName=campagneData.config?.donorName || "M2"

    const formater=new Intl.NumberFormat('fr-FR', { maximumFractionDigits:0 })

    return (
        <>
            <div style={{
                position: "absolute",
                top: "15vh",
                width: "100%",
                marginTop: "-2vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
            }}>
                <span className={"screen-count-text"} style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "25vh",
                    fontFamily: "Lust !important"
                }}><Counter number={total} decimals={0} preserveValue/></span>
            </div>


            <div style={{
                position: "absolute",
                top: "57vh",
                width: "53vw",
                height: "4vh",
                padding: "0.3vw",
                backgroundColor: "transparent",
                borderRadius: 40
            }}>
                <div style={{
                    width: displayPercent + "%",
                    height: "100%",
                    backgroundColor: "rgb(245,225,174)",
                    borderRadius: 40,
                }}/>
            </div>


            <div style={{
                position: "absolute",
                top: "63vh",
                width: "100%",
                textAlign:"center",
                color:"#FFF",
                fontSize:"4vh",
                fontFamily:"Noir-Medium"
            }}>
                <span>{formater.format(percent)}%</span>
            </div>

        </>
    )
}
